
import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'proposalsClient';
const endPointMail = 'mail';

// GET lAST PROPOSAL APPROVED
export const findLastProposalApproved = async projectId => {
  try {
    const { data } = await api.get(`/${endPoint}/findLastProposalApproved`, {
      params: { projectId },
    });
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// PAGINATION
export const paginationProposalClients = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllProposalClients = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createProposalClient = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateProposalClient = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteProposalClient = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// APPROVE
export const approveProposal = async formData => {
  try {
    const { data } = await api.post(`/${endPointMail}/proposalApproveAndSendMail`, formData);
    message.success(i18next.t(`messages:${endPoint}.successApproved`));
    return data;
  } catch (error) {
    throw error;
  }
};

paginationProposalClients.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllProposalClients.propTypes = {
  filters: PropTypes.object.isRequired,
};

createProposalClient.propTypes = {
  values: PropTypes.object.isRequired,
};

updateProposalClient.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteProposalClient.propTypes = {
  id: PropTypes.string.isRequired,
};
